import React from 'react';
import { Modal, Typography, Row, theme, Button, Col } from 'antd';
import QRCode from 'react-qr-code';
import { ReactComponent as SVGLogoAlyPlus } from "assets/img/aly_plus_dark_logo.svg";
import { themeColors } from 'theme';
import { useReactToPrint } from 'react-to-print';
import { getChargeLines, getAdmFeeLines } from 'services/solicitation-service';
import { SOLICITATION_TYPE } from 'utils/static-data';

const BENEFITS = {
    FREE: { id: -1, name: 'Livre' },
    FOOD: { id: 1, name: 'Alimentação' },
    MOBILITY: { id: 2, name: 'Mobilidade (Combustível)' },
    FREE_CARD: { id: 3, name: 'Livre Cartão' }
}

export const SolicitationSchedulePix = (props) => {
    const { open = false, onClose, pixQRCode = '', solicitation } = props;
    const [solicitationId, setSolicitationId] = React.useState(0);
    const [date, setDate] = React.useState('')
    const [completeDate, setCompleteDate] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [value, setValue] = React.useState(0);
    const [pagedLines, setPagedLines] = React.useState([]);
    const [qtdLines, setQtdLines] = React.useState(0);
    const [processingDate, setProcessingDate] = React.useState('');
    const [expiresIn, setExpiresIn] = React.useState(0);
    const [company, setCompany] = React.useState({});
    const [address, setAddress] = React.useState('');
    const [totalFee, setTotalFee] = React.useState(0);
    const [incomeFee, setIncomeFee] = React.useState(0);
    const [chargeFee, setChargeFee] = React.useState(0);
    const [partChargeFee, setPartChargeFee] = React.useState(0);
    const componentRef = React.useRef();

    React.useEffect(() => {
        if (solicitation) {
            setSolicitationId(solicitation.id);
            setTitle(solicitation.name);
            setValue(solicitation.value);
            setTotalFee(solicitation.totalFee);
            setIncomeFee(solicitation.incomeFee);
            setDate(formatDate(solicitation.pixQRCodeCreatedAt ? solicitation.pixQRCodeCreatedAt : new Date()));
            setCompleteDate(formatDateTime(solicitation.pixQRCodeCreatedAt ? solicitation.pixQRCodeCreatedAt : new Date()));
            setProcessingDate(new Date().toLocaleDateString("pt-BR"));
            setExpiresIn((solicitation ? solicitation.approval.approvalAt : new Date()));
            setAddress(solicitation?.company.address);
            setCompany(solicitation?.company);
            load();
        }
    }, [props, solicitation])

    const load = async () => {
        const admFees = await getAdmFeeLines(solicitation.id);
        admFees && setChargeFee(admFees.chargeFee);
        admFees && setPartChargeFee(admFees.partChargeFee);
        let pagedLines = [[]];
        if ([SOLICITATION_TYPE.CHARGE.code, SOLICITATION_TYPE.REDEEM.code, SOLICITATION_TYPE.SCHEDULE.code].includes(solicitation.type.code)) {
            let lines = await getChargeLines(solicitation.id);
            lines = lines.sort((a, b) => {
                if (!a.name) return 1;
                if (!b.name) return -1;
                return a.name.localeCompare(b.name);
            });
            setQtdLines(lines.length);
            const calculatedTotals = calculateTotals(lines);
            pagedLines = chunkLines(lines, 30);
            const lastPageIndex = pagedLines.length - 1;
            pagedLines[lastPageIndex].push({
                name: 'Total',
                cpf: `${formatCurrency(calculatedTotals['Total'])}`,
                benefits: [
                    { benefitID: BENEFITS.FREE.id, value: calculatedTotals['Total'] },
                    { benefitID: BENEFITS.FREE.id, value: calculatedTotals['FREE'] },
                    { benefitID: BENEFITS.FOOD.id, value: calculatedTotals['FOOD'] },
                    { benefitID: BENEFITS.MOBILITY.id, value: calculatedTotals['MOBILITY'] },
                    { benefitID: BENEFITS.FREE_CARD.id, value: calculatedTotals['FREE_CARD'] },
                ]
            });
        }
        setPagedLines(pagedLines);
    }

    const chunkLines = (lines, chunkSize = 30) => {
        const pagedLines = [];
        for (let i = 0; i < lines.length; i += chunkSize) {
            const chunk = lines.slice(i, i + chunkSize);
            pagedLines.push(chunk);
        }
        return pagedLines;
    };

    const calculateTotals = (lines) => {
        const totals = { 'Total': 0, 'FREE': 0, 'FOOD': 0, 'MOBILITY': 0, 'FREE_CARD': 0 };

        lines.forEach(line => {
            line.benefits.forEach(b => {
                var benefitName = getBenefitName(b.name);
                totals[benefitName] = (totals[benefitName] || 0) + b.value;
                totals['Total'] = (totals['Total'] || 0) + b.value;
            });
        });
        return totals;
    };

    const getBenefitName = (benefit) => {
        switch (benefit) {
            case "Livre":
                return "FREE";
            case "Alimentação":
                return "FOOD";
            case "Mobilidade (Combustível)":
                return "MOBILITY";
            case "Livre Cartão":
                return "FREE_CARD";
            default:
                return "FREE";
        }
    };

    const colors = {
        border: '#e5e7eb',
        row: '#ffffff',
        rowAlt: '#f9fafb',
        label: '#374151',
        value: '#111827'
    };

    const Wrapper = ({ children, style }) => (
        <div
            style={{
                border: `1px solid ${colors.border}`,
                //borderRadius: 12,
                overflow: 'hidden',
                ...style
            }}
        >
            {children}
        </div>
    );

    const handlePrint = useReactToPrint({
        bodyClass: "print-body",
        copyStyles: true,
        onAfterPrint: () => {
            //setPrintShow(false)
        },
        content: () => componentRef.current,
    });

    const formatDateTime = (dateInput) => {
        const date = new Date(dateInput);

        const formattedDate = formatDate(date);

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${formattedDate} ${hours}:${minutes}:${seconds}`;
    }

    const formatDate = (dateInput) => {
        if (typeof dateInput === 'string' && String(dateInput).includes('-')) {
            const [year, month, day] = dateInput.split("-");
            return `${day}/${month}/${year}`
        } else {
            const date = new Date(dateInput);

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            return `${day}/${month}/${year}`;
        }
    }

    const maskCNPJ = (value) => {
        if (!value) return "";
        const digits = value.replace(/\D/g, "");
        return digits
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2")
            .slice(0, 18);
    }

    const maskZipCode = (value) => {
        if (!value) return "";
        const digits = value.replace(/\D/g, "");
        return digits.replace(/^(\d{5})(\d)/, "$1-$2").slice(0, 9);
    }

    const TD = ({ children, isLastCol, isLastRow, alignRight, bold, style }) => (
        <td
            style={{
                padding: '12px 10px',
                borderRight: isLastCol ? 'none' : `1px solid ${colors.border}`,
                borderBottom: isLastRow ? 'none' : `1px solid ${colors.border}`,
                verticalAlign: 'top',
                color: colors.value,
                fontWeight: bold ? 600 : 400,
                textAlign: alignRight ? 'right' : 'left',
                fontSize: 12,
                lineHeight: 1.25,
                ...style
            }}
        >
            {children}
        </td>
    );

    const Footer = ({ style }) => (
        <>
            <style>
                {`
                @media print {
                    .print-footer {
                        position: fixed;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        .text-footer {
                            font-size: 12px
                        }
                    }
                }
            `}
            </style>
            <div className="print-footer" style={{ textAlign: 'center', color: themeColors.mediumColor, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginTop: 40, ...style }}>
                <div></div>
                <div className="text-footer"><span style={{ color: themeColors.highlightColor }}>www.alyplus.com</span><br />contato@alyplus.com</div>
                <div></div>
            </div>
        </>
    );

    const Header = ({ style, pageBreakAfter = false }) => (
        <>
            <style>
                {`
                @media print {
                    .print-body {
                        height: 0 !important
                    }
                }
                `}
            </style>
            { pageBreakAfter &&
                <>
                    <div style={{pageBreakAfter: 'always'}}></div>
                    <div class="print-body" style={{ height: '100px', display: 'flex', alignItems: 'center' }}>
                        <hr style={{ borderTop: '1px dashed #d3d3d3', width: '100%', borderBottom: 'none' }} />
                    </div>
                </>
            }
            <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                <Col>
                    <SVGLogoAlyPlus height={80} width={80} className="logo-login" />
                </Col>
                <Col>
                    <Typography.Text style={{ fontSize: 14 }}>
                        Documento gerado em: {completeDate}
                    </Typography.Text>
                </Col>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: 12 }}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                    Agendamento {title}
                </Typography.Title>
            </Row>
            <div style={{ height: 1, marginBottom: 20 }} />
        </>
    )

    const Label = ({ children, strong, style }) => (
        <div style={{ color: colors.label, fontWeight: strong ? 700 : 500, ...style }}>{children}</div>
    );

    const Value = ({ children, strong, alignRight, style }) => (
        <div style={{ marginTop: 4, fontWeight: strong ? 700 : 400, textAlign: alignRight ? 'right' : 'left', ...style }}>{children}</div>
    );

    const formatCurrency = (amount) => {
        const formattedAmount = amount? amount.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }): "R$ 0,00";

        return formattedAmount;
    }

    const SolicitationTable = ( { lines } ) => (
        <>
            {lines && lines.length > 0 && lines.map((pageLines, pageIndex) => (
                <React.Fragment key={pageIndex}>
                    <Header pageBreakAfter={true} />
                    <Wrapper>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ background: themeColors.mediumColor, color: themeColors.softColor, border: `1px solid ${themeColors.mediumColor}` }}>
                                    <td style={{ paddingLeft: 10 }}>Participante</td>
                                    <td style={{ textAlign: 'center' }}>CPF</td>
                                    <td style={{ paddingLeft: 16 }}>{BENEFITS.FREE.name}</td>
                                    <td style={{ paddingLeft: 16 }}>{BENEFITS.FOOD.name}</td>
                                    <td style={{ paddingLeft: 16 }}>{BENEFITS.MOBILITY.name}</td>
                                    <td style={{ paddingLeft: 16 }}>{BENEFITS.FREE_CARD.name}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {pageLines.map((line, index) => {
                                    const isTotalRow = line.name === 'Total';
                                    const isEven = index % 2 === 0 && !isTotalRow;

                                    const benefitsMap = {};
                                    line.benefits.forEach(b => {
                                        benefitsMap[b.benefitID] = b.value;
                                    });

                                    return (
                                        <tr key={index} style={{
                                            background: isTotalRow ? themeColors.mediumColor : (isEven ? "#D9E2F3" : "#FFFFFF"),
                                            border: `1px solid ${themeColors.mediumColor}`,
                                            fontWeight: isTotalRow ? 700 : 400,
                                            color: isTotalRow ? themeColors.softColor : themeColors.darkColor
                                        }}>
                                            <td style={{ padding: 5, paddingLeft: 10, textAlign: 'left' }}>{line.name}</td>
                                            <td style={{ padding: 5, textAlign: 'center' }}>{line.cpf}</td>
                                            <td style={{ padding: 5, textAlign: 'left' }}>{formatCurrency(benefitsMap[BENEFITS.FREE.id])}</td>
                                            <td style={{ padding: 5, textAlign: 'left' }}>{formatCurrency(benefitsMap[BENEFITS.FOOD.id])}</td>
                                            <td style={{ padding: 5, textAlign: 'left' }}>{formatCurrency(benefitsMap[BENEFITS.MOBILITY.id])}</td>
                                            <td style={{ padding: 5, textAlign: 'left' }}>{formatCurrency(benefitsMap[BENEFITS.FREE_CARD.id])}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Wrapper>
                    <Footer />
                </React.Fragment>
            ))}
        </>
    );

    return (
        <Modal
            open={open}
            title={null}
            footer={
                [
                    <Button key="submit" type="primary" loading={false} onClick={handlePrint}>
                        Imprimir
                    </Button>
                ]
            }
            width={794}
            height={1123}
            onCancel={onClose}
            destroyOnClose
            style={{ top: 20 }}
        >
            <div ref={componentRef} style={{ padding: 24, fontSize: 12 }}>
                <Header />
                <Wrapper>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                            <tr style={{ background: colors.rowAlt }}>
                                <TD>
                                    <Label>Beneficiário</Label>
                                    <Value strong>Alyplus Tecnologia e Soluções de Pagamento Ltda.</Value>
                                </TD>
                                <TD style={{ width: '177px' }} isLastCol>
                                    <Label>Vencimento</Label>
                                    <Value strong alignRight >{formatDate(expiresIn)}</Value>
                                </TD>
                            </tr>

                            <tr style={{ background: colors.row, borderBottom: `1px solid ${colors.border}` }}>
                                <tr style={{ background: colors.row }}>
                                    <td>
                                        <TD style={{ borderBottom: 'none' }}>
                                            <Label>Data do documento</Label>
                                            <Value strong>{date}</Value>
                                        </TD>
                                        <TD style={{ borderBottom: 'none' }}>
                                            <Label>Qtd. Participantes</Label>
                                            <Value strong>{qtdLines}</Value>
                                        </TD>
                                        <TD style={{ borderBottom: 'none' }}>
                                            <Label>Espécie</Label>
                                            <Value strong>R$</Value>
                                        </TD>
                                        <TD style={{ borderBottom: 'none', borderRight: 'none' }}>
                                            <Label>Data do processamento</Label>
                                            <Value strong>{processingDate}</Value>
                                        </TD>
                                    </td>
                                </tr>
                                <TD style={{ borderLeft: `1px solid ${colors.border}` }} isLastCol alignRight>
                                    <Label style={{ textAlign: 'left'}}>Nº Pedido</Label>
                                    <Value strong alignRight>{solicitationId}</Value>
                                </TD>
                            </tr>

                            <tr style={{ background: colors.row }}>
                                <TD>
                                    <Label>Nº da Conta/Respo.</Label>
                                    <Value></Value>
                                </TD>
                                <TD style={{ width: '177px' }} isLastCol>
                                    <Label>(=) Valor do documento</Label>
                                    <Value strong alignRight >{formatCurrency(value)}</Value>
                                </TD>
                            </tr>

                            <tr style={{ background: colors.row }}>
                                <TD style={{ borderBottom: 'none', verticalAlign: 'center' }}>
                                    <tr>
                                        <TD style={{ width: '320px', padding: 0, border: 'none' }}>
                                            <Label>Copie e Cole</Label>
                                            <Value strong>
                                                <p style={{
                                                    marginTop: 8,
                                                    fontSize: 12,
                                                    wordBreak: 'break-all',
                                                    maxWidth: 320
                                                }}>
                                                    {pixQRCode}
                                                </p>
                                            </Value>
                                        </TD>

                                        <TD style={{ textAlign: 'center', width: '320px', padding: 0, border: 'none' }}>
                                            <div style={{ marginBottom: 10 }}>Escaneie o QR code para efetuar o pagamento.</div>
                                            {pixQRCode && (
                                                <>
                                                    <QRCode value={pixQRCode} size={160} />
                                                    <Typography.Paragraph
                                                        style={{
                                                            marginTop: 12,
                                                            fontSize: 12,
                                                            wordBreak: 'break-all',
                                                            maxWidth: 250,
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto'
                                                        }}
                                                    >
                                                    </Typography.Paragraph>
                                                </>
                                            )}
                                        </TD>
                                    </tr>
                                </TD>
                                <TD style={{ padding: 0 }} isLastCol alignRight>
                                    <div style={{ borderBottom: `1px solid ${colors.border}` }}>
                                        <TD style={{ borderRight: 'none', borderBottom: 'none' }}>
                                            <Label>(-) Desconto</Label>
                                            <Value strong></Value>
                                        </TD>
                                    </div>
                                    <div style={{ borderBottom: `1px solid ${colors.border}` }}>
                                        <TD style={{ borderRight: 'none', borderBottom: 'none' }}>
                                            <Label>(-) Outras deduções</Label>
                                            <Value strong></Value>
                                        </TD>
                                    </div>
                                    <div style={{ borderBottom: `1px solid ${colors.border}` }}>
                                        <TD style={{ borderRight: 'none', borderBottom: 'none' }}>
                                            <Label>(+) Mora/Multa/Juros</Label>
                                            <Value strong></Value>
                                        </TD>
                                    </div>
                                    <div style={{ borderBottom: `1px solid ${colors.border}` }}>
                                        <TD style={{ width: '177px', borderRight: 'none', borderBottom: 'none' }}>
                                            <Label>(+) Taxas Adm.</Label>
                                            {(totalFee || incomeFee) &&
                                                <Value strong alignRight>{formatCurrency(totalFee + incomeFee)}</Value>
                                            }
                                        </TD>
                                    </div>
                                    <div>
                                        <TD style={{ width: '177px', borderBottom: 'none' }} isLastCol>
                                            <Label>(=) Valor Total</Label>
                                            <Value strong alignRight >{formatCurrency(value + totalFee + incomeFee)}</Value>
                                        </TD>
                                    </div>
                                </TD>
                            </tr>

                            <tr style={{ background: colors.row, borderTop: `1px solid ${colors.border}`, color: themeColors.darkColor }}>
                                <TD style={{ border: 'none', padding: 0 }}>
                                    <tr>
                                        <TD style={{ border: 'none' }}>
                                            Pagador:<br />
                                            <b>{company.corporateName} {company.businessType?.code}</b>
                                            <p style={{
                                                marginTop: 8,
                                                fontSize: 12,
                                                wordBreak: 'break-all',
                                                maxWidth: 320,
                                                fontWeight: 'normal'
                                            }}>
                                                {address.address}, {address.number} <br />
                                                {address.complement && <> {address.complement} <br /></>}
                                                Código Postal: {maskZipCode(address.zipcode)} <br />
                                                {address.neighborhood} - {address.city}/{address.state} <br />
                                            </p>
                                        </TD>
                                        <TD style={{ textAlign: 'center', border: 'none' }}>
                                            <Label strong>Nº da Inscrição: {maskCNPJ(company.cnpj)}</Label>
                                        </TD>
                                    </tr>
                                </TD>
                                <TD style={{ textAlign: 'end', verticalAlign: 'bottom', borderBottom: 'none', paddingBottom: 0, paddingRight: 12 }} isLastCol alignRight></TD>
                            </tr>
                        </tbody>
                    </table>
                </Wrapper>
                <Wrapper style={{ marginTop: 16 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <tbody>
                            <tr style={{ background: themeColors.mediumColor, color: themeColors.softColor }}>
                                <td style={{ paddingLeft: 16 }}>
                                    Observações:
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: 16, color: themeColors.darkColor }}>
                                    Consulte os horários de cargas agendadas com o time Aly+
                                    <br />O Boleto"Pix", não poderá ser pago após 5 dias do seu vencimento
                                    <br />
                                    <br />Outros acrescimos: {formatCurrency(chargeFee + partChargeFee)}
                                    <br />- Taxa Adm. {formatCurrency(chargeFee)}
                                    <br />- Taxa de Carga {formatCurrency(partChargeFee)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Wrapper>
                <Footer />
                <SolicitationTable lines={pagedLines} />
            </div>
        </Modal>
    );
};
